export const FEEDBACK_ANSWER_MIN = 6;

export type FeedbackAnswerProblem = 'empty' | 'too_short' | 'filler';

const MEANINGFUL = /[\p{L}\p{N}]/gu;

function meaningfulCharacters(text: string): string[] {
  return (
    text.toLocaleLowerCase('nl-NL').normalize('NFKD').replace(/\p{M}/gu, '').match(MEANINGFUL) ?? []
  );
}

export function feedbackAnswerProblem(text: string): FeedbackAnswerProblem | null {
  const trimmed = text.trim();
  if (trimmed === '') {
    return 'empty';
  }
  const characters = meaningfulCharacters(trimmed);
  if (characters.length < FEEDBACK_ANSWER_MIN || trimmed.length < FEEDBACK_ANSWER_MIN) {
    return 'too_short';
  }
  const distinct = new Set(characters);
  if (distinct.size < 3) {
    return 'filler';
  }
  const commonest = Math.max(
    ...[...distinct].map((character) => characters.filter((item) => item === character).length),
  );
  return commonest / characters.length > 0.6 ? 'filler' : null;
}

export function feedbackAnswerKey(text: string): string {
  return meaningfulCharacters(text).join('');
}

export function repeatedFeedbackAnswers(answers: readonly string[]): number[] {
  const seen = new Map<string, number>();
  const repeated: number[] = [];
  answers.forEach((answer, index) => {
    const key = feedbackAnswerKey(answer);
    if (key === '') {
      return;
    }
    if (seen.has(key)) {
      repeated.push(index);
    } else {
      seen.set(key, index);
    }
  });
  return repeated;
}
